
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practice-areas/mediation",
      function () {
        return require("private-next-pages/practice-areas/mediation/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practice-areas/mediation"])
      });
    }
  